import * as PIXI from "pixi.js";
import ServiceLocator from "../../ServiceLocator";
import { Profile } from "../../lib/game_snacks/IUser";
import Utils from "../../Utils";
import GSAvatarLoader from "../../lib/GSAvatarLoader";


export default class PlayerSlot extends PIXI.Container
{
    // #region Attributes //

    // private:

    private _portrait: PIXI.Sprite = null;
    private _username: PIXI.Text = null;

    private _profile: Profile = null;

    private _disabledFilter: PIXI.Filter = null;

    private readonly _kPortraitWidth: number = 222;

    // #endregion //


    public get isEmpty(): boolean { return this._profile == null; }


    // #region Methods //

    // public:

    public constructor( baseTexture: PIXI.Texture ) 
    { 
        super(); 

        let base: PIXI.Sprite = new PIXI.Sprite( baseTexture );
        base.anchor.set( 0.5 );
        this.addChild( base );

        this._portrait = new PIXI.Sprite( ServiceLocator.resources.avatar_unknown.texture );
        this._portrait.scale.set( this._kPortraitWidth / this._portrait.texture.width );
        this._portrait.anchor.set( 0.5 );
        this.addChild( this._portrait );     
        //
        this._disabledFilter = new PIXI.filters.ColorMatrixFilter();
        ( this._disabledFilter as any ).grayscale( 0.3, false );
        this._disabledFilter.enabled = false;
        this._disabledFilter.resolution = 8;
        this._portrait.filters = [ this._disabledFilter ];

        this._username = new PIXI.Text( "", {
            /*fontSize: 50,
            fontFamily: "jaro_regular", 
            fill: 0xffffff, 
            stroke: 0x000000, 
            strokeThickness: 4,
            dropShadow: true,
            dropShadowAngle: 2,
            dropShadowColor: "#000000",
            dropShadowDistance: 2 
        } );*/
            fontSize: 50, 
            fontFamily: "teko_regular", 
            fill: 0x192f62, 
            stroke: 0xffffff, 
            strokeThickness: 8,
            dropShadow: true,
            dropShadowAngle: 2,
            dropShadowColor: "#ffffff",
            dropShadowDistance: 2,
            lineJoin: "round"
        } );
        this._username.anchor.set( 0.5, 1 );
        this._username.position.set( 0, 180 );
        this.addChild( this._username );    
    }

    public setPlayer( profile: Profile ): void
    {
        this._profile = profile;
    
        GSAvatarLoader.i.load( 
            profile.avatar.src, 
            ( texture: PIXI.Texture ) => {
                // TODO: The screen containing the player slot might be destroyed, but the callback is still active!!!
                try 
                {
                    this._portrait.texture = texture;
                    this._portrait.scale.set( this._kPortraitWidth/this._portrait.texture.width ); 
                } 
                catch( ex ) {}
            } );
        
        this._username.text = profile.username.prefix;
        this._username.scale.set( 1 );
        Utils.fitTextToWidth( this._username, 200 );
    }

    public setPortraitDisabled( isDisabled: boolean ): void
    {
        this._disabledFilter.enabled = isDisabled;
    }

    public isPlayer( profile: Profile ): boolean
    {
        return this._profile.uid == profile.uid;
    }

    public empty(): void
    {
        this._portrait.texture = ServiceLocator.resources.avatar_unknown.texture;
        this._portrait.scale.set( this._kPortraitWidth / this._portrait.texture.width );
        
        this._username.text = "";

        this._profile = null;
    }

    // #endregion //
}